<template>
    <Popconfirm
        :title="title"
        :ok-text="okText"
        :cancel-text="cancelText"
        :ok-type="type"
        v-bind="{...$attrs, ...$props}"
        v-on="$listeners"
    >
        <slot />
    </Popconfirm>
</template>

<script>
import { Popconfirm } from 'ant-design-vue';
export default {
    name: 'ConfirmDangerousAction',
    components: {
        Popconfirm,
    },
    props: {
        type: {
            type: String,
            default: 'danger',
            validator(type) {
                return ['danger', 'primary'].includes(type);
            },
        },
        title: {
            type: String,
            default() {
                return this.$t('areYouSure');
            },
        },
        okText: {
            type: String,
            default() {
                return this.$t('yes');
            },
        },
        cancelText: {
            type: String,
            default() {
                return this.$t('no');
            },
        },
    },
};
</script>

<style>

</style>